import { Spin } from 'antd';

export const FullScreenLoading = (): React.ReactElement => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
        zIndex: 9999,
      }}
    >
      <Spin size="large" />
    </div>
  );
};
